import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { validaSoloNumero, diasMes, lpad } from "../../util/varios";
import { Mensaje } from "../mensajes2";
import moment from "moment";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentasBancarias";
import { Dimmer } from "../spinner";
import { Input, SearchInput, Select } from "../../ui/inputs/Input";

export const ImpMovBanLibro = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  let post = JSON.parse(localStorage.getItem("post"));

  const [disabledInput, setDisabledInput] = useState(0);

  const [activate, setActivate] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);

  const [deshabilitado, setDeshabilitado] = useState(true);
  const [cmbAnios, setCmbAnios] = useState();
  const [cmbMeses, setCmbMeses] = useState();
  const [activo, setActivo] = useState(true);
  const [desde, setDesde] = useState(0);

  const [newAnio, setNewAnio] = useState()
  const [newMonth, setNewMonth] = useState()

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [datos] = useState();
  const [fechaUD, setFechaUD] = useState();

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtNumFactura = useRef();
  const txtNumControl = useRef();
  const txtFecha = useRef();
  const txtIdCuenta = useRef();
  const txtNomBanco = useRef();
  const txtNumCuenta = useRef();
  const txtFechaConRef = useRef();

  const cmbMesRef = useRef();
  const cmbAnioRef = useRef();

  const cancelar = () => {
    props.setShow(false)
    blanquear();
  };

  const blanquear = () => {
    setActivate(false);
    setActivo(true);
    setDeshabilitado(true);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onDatos(datos);
    props.setShow(false)
    blanquear();
  };
  const handleInputNumChange = (event) => {
    event.preventDefault();
    if (event.target.id === "numoperacion") {
      validaSoloNumero(event);
    }

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "numoperacion") {
          txtNumFactura.current.focus();
        } else if (event.target.id === "numfactura") {
          txtNumControl.current.focus();
        } else if (event.target.id === "numcontrol") {
          txtFecha.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const seleccionarCuentaBancaria = (codigo) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcuentabancaria > 0) {
            txtIdCuenta.current.value = response.data.idcuentabancaria;
            txtNomBanco.current.value = response.data.nombre;
            txtNumCuenta.current.value = response.data.cuentabancaria;
            setDisabledInput(2);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o Cuenta Bancaria, No esta Registrado!",
              icono: "error",
            });
            txtIdCuenta.current.value = "";
            txtNomBanco.current.value = "";
            txtNumCuenta.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCuentaBancaria = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuentaBancaria(event.target.value);
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (!txtIdCuenta.current.value) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Debe ingresar o seleccioanr una cuenta bancaria",
        icono: "informacion",
      });
      sigue = false;
      txtIdCuenta.current.focus();
    }

    if (sigue) {
      let reporte = "Tes_LibroAuxMensualA";


      let anio = parseInt(cmbAnioRef.current.value);
      /* let ini = 
        cmbMesRef.current.value.length === 2
          ? '"' + anio + "-" + cmbMesRef.current.value + '-01"'
          : '"' + anio + "-0" + cmbMesRef.current.value + '-01"';  */
      let ini = '"' + anio + "-" + lpad(cmbMesRef.current.value.toString().trim(), "00", 2) + '-01"';

      /* let fin =
        cmbMesRef.current.value.length === 2
          ? '"' +
            cmbAnioRef.current.value +
            "-" +
            cmbMesRef.current.value +
            '-01"'
          : '"' +
            parseInt(cmbAnioRef.current.value) +
            "-0" +
            cmbMesRef.current.value +
            '-01"';*/
      let fin = '"' + anio + "-" + lpad(cmbMesRef.current.value.toString().trim(), "00", 2) + "-" + diasMes(parseInt(cmbMesRef.current.value), anio) + '"';

      let sql = "doc_fechae between '" + ini + "' AND '" + fin + "'";
      // let sql2 = "DESDE EL '" + ini + "' HASTA EL '" + fin + "'";
      let sql3 = "c.idcuentabancaria = " + txtIdCuenta.current.value;
      let sql4 = "AND true";
      let tit = lpad(cmbMesRef.current.value.toString().trim(), "00", 2) + '/' + anio;
      let org = post.nombreorg;
      window.open(
        op.reportes + "/administracionTesoreria?" +
        "reporte=" +
        reporte +
        "&sql=" +
        encodeURIComponent(sql) +
        "&sql3=" +
        encodeURIComponent(sql3) +
        "&sql4=" +
        encodeURIComponent(sql4) +
        "&ini=" +
        encodeURIComponent(ini) +
        "&fin=" +
        encodeURIComponent(fin) +
        "&tit=" +
        encodeURIComponent(tit) +
        "&org=" +
        encodeURIComponent(org) +
        "&ciu=" +
        encodeURIComponent(' '),
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700" 
      );
    }
  };

  const handleCancelaCuentaBancaria = () => {
    setMostrar5(false);
  };

  const handleAceptarCuentaBancaria = (datos) => {
    setMostrar5(false);
    setDisabledInput(2);
    txtIdCuenta.current.value = datos.idcuentabancaria;
    txtNomBanco.current.value = datos.nombre;
    txtNumCuenta.current.value = datos.cuentabancaria;
  };

  const LlenarComboAnio = () => {
    var n = new Date().getFullYear();
    var afin = parseInt(n) - 7;
    var a = [];
    for (var i = n; i >= afin; i--) {
      a.push({ anio: i });
    }
    cmbAnioRef.current.value = n;
    setCmbAnios(a);
    const newAnioArr = a.map((item) => {
      return { value: item.anio, label: item.anio }
    })
    setNewAnio(newAnioArr)
    var meses = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    var m = [];
    for (var x = 0; x < 12; x++) {
      m.push({ nummes: x + 1, mes: meses[x] });
    }
    cmbMesRef.current.value = 1;

    const newArr = m.map((item) => {
      return { value: item.nummes, label: item.mes }
    });
    setNewMonth(newArr)
    setCmbMeses(m);
  };

  const catalogoCuentaBancaria = (e) => {
    e.preventDefault();
    setMostrar5(true);
  };
  const validarPeriodo = (event) => {
    setDesde(0);

    let fecPer =
      cmbAnioRef.current.value +
      "-" +
      cmbMesRef.current.value.toString().padStart(2, 0) +
      "-01";
    if (txtFechaConRef.current) {
      if (fecPer > moment.utc(txtFechaConRef.current.value).format("YYYY-MM-DD")) {
        cmbMesRef.current.value = 1;
        cmbAnioRef.current.value = new Date(
          txtFechaConRef.current.value
        ).getFullYear();
        let fecUD =
          cmbAnioRef.current.value +
          "-" +
          cmbMesRef.current.value.toString().padStart(2, 0) +
          "-" +
          new Date(cmbAnioRef.current.value, cmbMesRef.current.value, 0)
            .getDate()
            .toString()
            .padStart(2, 0);
        setFechaUD(fecUD);
        return false;
      } else {
        let fecUD =
          cmbAnioRef.current.value +
          "-" +
          cmbMesRef.current.value.toString().padStart(2, 0) +
          "-" +
          new Date(cmbAnioRef.current.value, cmbMesRef.current.value, 0)
            .getDate()
            .toString()
            .padStart(2, 0);
        setFechaUD(fecUD);
        return true;
      }
    }

  };

  useEffect(() => { }, []);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setActivo(false);
        LlenarComboAnio();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 text-light fw-bold m-0">
          Movimientos Bancarios Según Libros
        </h3>
        <btn onClick={cancelar} className="btn btn-sm bg-light">
          <i className="fa fa-times"></i>
        </btn>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted>

        </Dimmer>
        <fieldset className="col-12 p-2 m-0 rounded border-azul d-flex flex-wrap align-items-center">
          <legend className="float-none m-0 w-auto fw-bold">
            Datos del Banco
          </legend>
          <div className="col-4 input-group input-group-sm m-0 mb-2 p-0">
            <SearchInput label='Código:'
              /* disabled={
                disabledInput === 1
                  ? false
                  : disabledInput === 2
                    ? false
                    : true
              } */
              onChange={handleInputNumChange}
              onKeyUp={handleCuentaBancaria}
              onBlur={handleInputNumChange}
              id="idcuenta"
              onClickButton={catalogoCuentaBancaria}
              ref={txtIdCuenta}
            />
          </div>

          <div className="col-12 m-0 mb-2 p-0 d-flex flex-wrap">
            <div className="col-12 m-0 p-0">
              <Input label='Banco:'
                maxLength={12}
                disabled={true}
                id="inputDireccion"
                ref={txtNomBanco}
              />
            </div>
            <div className="col-6 m-0 ml-auto p-0">
              <Input
                inputClassName='text-end'
                disabled={true}
                id="inputDireccion"
                ref={txtNumCuenta}
              />
            </div>
          </div>
          <div className="col-6 m-0 p-0">
            <Select label='Mes:'
              disabled={disabledInput === 2 ? false : true}
              onChange={validarPeriodo}
              ref={cmbMesRef}
              options={newMonth}
            />
          </div>
          <div className="col-6 p-0 pl-2 m-0">
            <Select label='Año:'
              disabled={disabledInput === 2 ? false : true}
              id="anio"
              onChange={validarPeriodo}
              ref={cmbAnioRef}
              options={newAnio}
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end gap-2">
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={activo}
          className="fw-bold btn btn-success col-md-3 btn-sm rounded-pill">
          <i className="far fa-check-circle"></i> Imprimir
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          className="fw-bold btn btn-sm bg-danger rounded-pill col-md-3 text-light">
          <i className="fas fa-window-close"></i> Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <CatalogoCuentaBancaria
        show={mostrar5}
        onHideCancelar={handleCancelaCuentaBancaria}
        onHideAceptaCatalogo={handleAceptarCuentaBancaria}
      />
    </Modal>
  );
};
